var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKeyReturn = function SvgIconKeyReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.75a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H9.914l.543.543a1 1 0 0 1-1.414 1.414l-2.25-2.25a1 1 0 0 1 0-1.414l2.25-2.25a1 1 0 0 1 1.414 1.414l-.543.543H15.5v-2a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 5.25c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75v13.5a1.75 1.75 0 0 1-1.75 1.75H3.75A1.75 1.75 0 0 1 2 18.75zm2 .25v13h16v-13z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconKeyReturn;